"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _components = require("../../../../components");

var _helpers = require("./helpers");

var _helpers2 = require("../../../../helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SupplierRows = function SupplierRows(props) {
  var isAvailable = props.isAvailable,
      query = props.query,
      maxItems = props.maxItems,
      config = props.config,
      searchTerm = props.searchTerm,
      setSupplierDetails = props.setSupplierDetails,
      newLocation = props.newLocation,
      env = props.env,
      mobile = props.mobile,
      setCurItem = props.setCurItem,
      onItemsLoaded = props.onItemsLoaded,
      priceFilter = props.priceFilter;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      suppliers = _useState2[0],
      setSuppliers = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      curSupplier = _useState4[0],
      setCurSupplier = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      allItems = _useState6[0],
      setAllItems = _useState6[1];

  (0, _react.useEffect)(function () {
    setSuppliers(props.suppliers);
  }, [props.suppliers, query, newLocation]);
  (0, _react.useEffect)(function () {
    if (curSupplier) (0, _helpers.updateSuppliers)({
      supplier: curSupplier,
      setSuppliers: setSuppliers,
      suppliers: suppliers,
      setCurSupplier: setCurSupplier,
      isAvailable: isAvailable
    });
  }, [curSupplier]);
  (0, _react.useEffect)(function () {
    onItemsLoaded(allItems);
  }, [allItems]);
  (0, _react.useEffect)(function () {
    if (suppliers) {
      (0, _helpers.getItems)({
        query: query,
        suppliers: suppliers,
        location: newLocation ? newLocation.location : null,
        config: config,
        env: env,
        setSuppliers: setSuppliers,
        setCurSupplier: setCurSupplier,
        setAllItems: setAllItems
      });
    }
  }, [query, newLocation]);

  if (suppliers) {
    return suppliers.map(function (supplier, i) {
      if (supplier.items) {
        return /*#__PURE__*/_react["default"].createElement(_components.SupplierRow, {
          isAvailable: isAvailable,
          supplier: supplier,
          items: priceFilter && priceFilter.id !== 1 ? (0, _helpers2.sortByPrice)(_objectSpread({}, supplier.items), priceFilter.id) : supplier.items,
          query: query,
          maxItems: maxItems,
          key: i,
          config: config,
          searchTerm: searchTerm,
          onLocationClick: function onLocationClick(result) {
            return setSupplierDetails(result);
          },
          newLocation: newLocation && newLocation.supplier.Id === supplier.Id ? newLocation : null,
          env: env,
          mobile: mobile,
          setCurItem: setCurItem
        });
      } else {
        return /*#__PURE__*/_react["default"].createElement(_components.SupplierRow, {
          key: i,
          maxItems: maxItems,
          loading: true
        });
      }
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", null);
};

var _default = SupplierRows;
exports["default"] = _default;